import { Notify } from "notiflix/build/notiflix-notify-aio";

export async function toastSucesso(mensagem) {
    Notify.success(mensagem);
}
